<template>
  <div>
    <mobile-calendar v-if="isH5" />
    <pc-calendar v-else />
  </div>
</template>

<script>
import { isH5 } from "@saas/components";
import PcCalendar from "./PcCalendar";
import mobileCalendar from "./MobileCalendar.vue";
export default {
  data: function () {
    return {
      isH5: isH5(),
    };
  },
  components: {
    "pc-calendar": PcCalendar,
    "mobile-calendar": mobileCalendar,
  },
};
</script>

<style lang="scss" scoped></style>
